<template>
  <div class="certificado-editor">

    <div id="page-loading" v-if="pageLoading===true">
      <i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw"></i>
      <span>Aguarde um momento</span>
    </div>

    <div class="row-flex" v-if="certificadoDados">
      <!-- Component heading -->
      <div class="col-12">
        <h2 class="vp-h2 vp-module-heading" v-if="id==='0'">
          Novo certificado
        </h2>
        <h2 class="vp-h2 vp-module-heading" v-else>
          Editar certificado: <span style="text-transform: none; margin-right: 20px;">{{certificadoDados.nome}}</span>
          <small class="n-ativo" v-if="certificadoDados.ativo==='0' && activateFlag===false">
            <i class="fa fa-fw fa-times-circle-o"></i>Não ativo
            <a href="javascript:void(0)" class="btn btn-sm" v-on:click="handleCertificateStatus()">Ativar</a>
          </small>
          <small class="n-ativo" v-if="certificadoDados.ativo==='1' && activateFlag===true">
            <i class="fa fa-fw fa-check-circle-o"></i>Ativação em espera <small>(Salve o certificado para confirmar)</small>
          </small>
          <small class="ativo" v-if="certificadoDados.ativo==='1' && activateFlag===false">
            <i class="fa fa-fw fa-check-circle"></i>Ativo
            <a href="javascript:void(0)" class="btn btn-sm" v-on:click="handleCertificateStatus()">Desativar</a>
          </small>
          <small class="ativo" v-if="certificadoDados.ativo==='0' && activateFlag===true">
            <i class="fa fa-fw fa-check-circle-o"></i>Desativação em espera <small>(Salve o certificado para confirmar)</small>
          </small>
        </h2>
      </div>

      <div class="col-12">

        <form v-on:submit.prevent="submitCertificateData()">

          <div class="form-group row-flex">
            <label class="col-12 control-label">
              <span style="color: red;">*</span>
              Nome:
            </label>
            <div class="col-12  small-6">
              <input type="text" class="form-control"
                  :name="'campo_'+certificadoDados.id"
                  placeholder="Escolha um nome para identificar o certificado"
                  v-model="certificadoDados.nome">
              <small>(Máximo de 45 caracteres)</small>
            </div>
          </div>

          <div class="form-group row-flex">
            <label class="col-12 control-label">
              Tipo de certificado:
            </label>
            <div class="col-12  small-6">
              <select class="form-control" :name="'campo_'+certificadoDados.id" v-model="certificadoDados.tipo">
                <option value="evento">Certificado do evento</option>
                <option value="trabalho">Certificado de trabalho</option>
                <option value="atividade" :selected="id=='0' && activeEventCertificate!='0'">Certificado de uma atividade</option>
              </select>

              <small class="attention" v-if="certificadoDados.tipo==='evento' && id!=activeEventCertificate && activeEventCertificate!='0'">Um outro certificado já está sendo utilizado como certificado deste evento<span v-if="id==='0'">.<br>Se você criar um novo certificado de evento, o anterior será DESABILITADO e o novo ficará ativo e disponível aos participantes</span></small>
            </div>
          </div>

          <div class="form-group row-flex">
            <label class="col-12 control-label">
              Formato do certificado:
            </label>
            <div class="col-12 small-6">
              <div class="row-flex">
                <span class="col-6">
                  <input type="radio" name="formato" id="formato_paisagem" value="paisagem" v-model="certificadoDados.configs.formato" />
                  <label for="formato_paisagem">
                    Paisagem
                  </label>
                </span>
                <span class="col-6">
                  <input type="radio" name="formato" id="formato_retrato" value="retrato" v-model="certificadoDados.configs.formato" />
                  <label for="formato_retrato">
                    Retrato
                  </label>
                </span>
              </div>
            </div>
          </div>

          <div class="form-group row-flex">
            <label class="col-12 control-label">
              Certificado sem margem?
            </label>
            <div class="col-12  small-6">
              <div class="row-flex">
                <span class="col-6">
                  <input type="radio" name="use_margin" id="use_margin_0" value="0" v-model="certificadoDados.configs.use_margin" />
                  <label for="use_margin_0">Sim</label>
                </span>
                <span class="col-6">
                  <input type="radio" name="use_margin" id="use_margin_1" value="1" v-model="certificadoDados.configs.use_margin" />
                  <label for="use_margin_1">Não</label>
                </span>
              </div>
            </div>
          </div>

          <div class="row-flex cert-tab-content">

            <!-- Tabs -->
            <ul class="control-tabs" :class="{'scrolled': scrolled}">
              <li :class="{'active':activeTab==='text'}">
                <a href="javascript:void(0)" v-on:click="changeTab('text')" v-tooltip.bottom="{content: '<strong>Texto do certificado</strong>', classes: 'tab-tooltip'}">
                  <i class="fa fa-fw fa-font"></i>
                  <span>Texto do certificado</span>
                </a>
              </li>
              <li v-show="hasVerso()" :class="{'active':activeTab==='text_verso'}">
                <a href="javascript:void(0)" v-on:click="changeTab('text_verso')" v-tooltip.bottom="{content: '<strong>Texto do verso do certificado</strong>', classes: 'tab-tooltip'}">
                  <i class="fa fa-fw fa-undo"></i>
                  <span>Texto do verso</span>
                </a>
              </li>
              <li :class="{'active':activeTab==='background'}">
                <a href="javascript:void(0)" v-on:click="changeTab('background')" v-tooltip.bottom="{content: '<strong>Imagem de fundo</strong>', classes: 'tab-tooltip'}">
                  <i class="fa fa-fw fa-image"></i>
                  <span>Imagem de fundo</span>
                </a>
              </li>
              <li :class="{'active':activeTab==='signatures'}">
                <a href="javascript:void(0)" v-on:click="changeTab('signatures')" v-tooltip.bottom="{content: '<strong>Assinaturas</strong>', classes: 'tab-tooltip'}">
                  <i class="fa fa-fw fa-pencil"></i>
                  <span>Assinaturas</span>
                </a>
              </li>
              <li :class="{'active':activeTab==='general'}">
                <a href="javascript:void(0)" v-on:click="changeTab('general')" v-tooltip.bottom="{content: '<strong>Configurações</strong>', classes: 'tab-tooltip'}">
                  <i class="fa fa-fw fa-cogs"></i>
                  <span>Configurações</span>
                </a>
              </li>
            </ul>

            <!-- Texto do certificado -->
            <div class="text col-12" v-show="activeTab==='text' || activeTab==='text_verso'">

              <h4 v-if="activeTab==='text'" class="vp-h4 tab-title">Texto do certificado</h4>
              <h4 v-else-if="activeTab==='text_verso'" class="vp-h4 tab-title">Texto do verso</h4>

              <div class="row-flex">
                <div class="col-12 small-6">

                  <div class="form-group row-flex">
                    <div class="col-12">
                      <h3 v-show="activeTab=='text_verso'">{{certificadoDados.tipo==='evento' ? 'Participante com Atividades' : 'Verso do certificado'}}</h3>
                      <tinymce id="editorUm" v-model="editor.um" :content="editorContent.um" :options="options" style='width:100%;'></tinymce>
                      <div v-show="activeTab=='text_verso'">
                        <div v-show="certificadoDados.tipo==='evento'">
                          <h3>Participante sem Atividades</h3>
                          <tinymce id="editorDois" v-model="editor.dois" :content="editorContent.dois" :options="options" style='width:100%;'></tinymce>
                        </div>
                        <h3>Rodapé do verso</h3>
                        <tinymce id="editorTres" v-model="editor.tres" :content="editorContent.tres" :options="options" style='width:100%;'></tinymce>
                      </div>
                    </div>
                  </div>

                  <div v-if="activeTab==='text'" class="form-group row-flex">
                    <label class="col-12 control-label">
                      Cor do texto no certificado:
                    </label>
                    <div class="col-12">
                      <compact-picker v-model="certificadoDados.configs.textoColor"></compact-picker>
                      <input type="text" class="form-control"
                          name="cor-texto"
                          placeholder="Insira a cor do texto em hexadecimal"
                          v-model="certificadoDados.configs.textoColor.hex"
                          disabled="disabled">
                    </div>
                  </div>
                  <div v-else-if="activeTab==='text_verso'" class="form-group row-flex">
                    <a style="margin-left: 10px;" class="btn vp-btn vp-action-btn" v-on:click="padraoVerso()">Restaurar padrão no verso</a>
                  </div>
                </div>

                <div class="col-12 small-6 tables">

                  <span>Insira os seguintes atalhos no certificado para adicionar dados específicos de cada participante em seu respectivo certificado<br><br></span>

                  <div class="vp-flextable alternate">
                    <div class="vp-ft-heading">
                      <div class="vp-ft-col">
                        Atalho<br><small>Relacionado ao evento</small>
                      </div>
                      <div class="vp-ft-col">
                        Descrição
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {nome}
                      </div>
                      <div class="vp-ft-col">
                        Nome do participante
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {categoria}
                      </div>
                      <div class="vp-ft-col">
                        Categoria em que o participante está inscrito
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {nome evento}
                      </div>
                      <div class="vp-ft-col">
                        O nome do evento
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {data inicio}
                      </div>
                      <div class="vp-ft-col">
                        Data de início do evento
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {data termino}
                      </div>
                      <div class="vp-ft-col">
                        Data de término do evento
                      </div>
                    </div>
                    <div class="vp-ft-row closeable" :class="{'expand': openMoreTags}" v-for="campo in camposForm" v-if="campo.nome!=='senha'">
                      <div class="vp-ft-col">
                        {{'{'+campo.titulo_r+'}'}}
                      </div>
                      <div class="vp-ft-col">
                        Irá exibir o campo <strong>{{campo.titulo}}</strong> do formulário
                      </div>
                    </div>
                    <a href="javascript:void(0)" class="open-more-tags-btn" v-on:click="openMoreTags = !openMoreTags">
                      <i class="fa fa-angle-double-up" v-if="openMoreTags"></i>
                      {{(openMoreTags ? 'Fechar' : 'Ver mais')}}
                      <i class="fa fa-angle-double-down"  v-if="!openMoreTags"></i>
                    </a>
                  </div>

                  <div class="vp-flextable alternate">
                    <div class="vp-ft-heading">
                      <div class="vp-ft-col">
                        Atalho<br><small>Relacionado às atividades</small>
                      </div>
                      <div class="vp-ft-col">
                        Descrição
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {total minutos}
                      </div>
                      <div class="vp-ft-col">
                        Os minutos do participante em todas as atividades
                      </div>
                    </div>
                    <div class="vp-ft-row">
                      <div class="vp-ft-col">
                        {total horas}
                      </div>
                      <div class="vp-ft-col">
                        As horas do participante em todas as atividades
                      </div>
                    </div>
                    <div class="vp-ft-row" v-if="certificadoDados.tipo==='atividade'">
                      <div class="vp-ft-col">
                        {lista atividades}
                      </div>
                      <div class="vp-ft-col">
                        Lista os nomes de todas as atividades
                      </div>
                    </div>
                    <div class="vp-ft-row" v-else>
                      <div class="vp-ft-col">
                        {listaAtividades}
                      </div>
                      <div class="vp-ft-col">
                        Lista os nomes de todas as atividades
                      </div>
                    </div>

                    <div class="vp-ft-row" v-if="certificadoDados.tipo==='atividade'">
                      <div class="vp-ft-col">
                        {horas atividade}
                      </div>
                      <div class="vp-ft-col">
                        Quantidade de horas da atividade do certificado
                      </div>
                    </div>
                    <div class="vp-ft-row" v-if="certificadoDados.tipo==='atividade'">
                      <div class="vp-ft-col">
                        {nome atividade}
                      </div>
                      <div class="vp-ft-col">
                        Nome da atividade do certificado
                      </div>
                    </div>
                  </div>
                  <div class="vp-flextable alternate">
                    <div class="vp-ft-heading">
                      <div class="vp-ft-col">
                        Atalho<br><small>Relacionado ao trabalho</small>
                      </div>
                      <div class="vp-ft-col">
                        Descrição
                      </div>
                    </div>
                    <div class="vp-ft-row" v-for="campo in trabalhoForm" v-if="campo.nome!=='senha'">
                      <div class="vp-ft-col">
                        {{'{'+campo.titulo+'}'}}
                      </div>
                      <div class="vp-ft-col">
                        Irá exibir o campo <strong>{{campo.titulo}}</strong> do formulário
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Imagem de fundo do certificado -->
            <div class="background col-12" v-show="activeTab==='background'">

              <h4 class="vp-h4 tab-title">Imagem de fundo do certificado</h4>

              <div class="row-flex">
                <div class="col-6 small-6 mid-4 big-3 background-item" v-for="model in models">
                  <a v-if="model.id != 0" href="javascript:void(0)" class="btn vp-delete-btn vp-btn btn-sm remove-btn" v-on:click="removeModel(model.id)">
                    <i class="fa fa-fw fa-times"></i>
                  </a>
                  <label :for="'modelo_'+model.id">
                    <div class="bg-item-wrapper">
                      <img :src="model.link ? url+model.link : undefined">
                      <table>
                        <tr>
                          <td
                            style="max-width: 20px;"
                            v-tooltip.bottom="{content: '<strong>Imagem de fundo da capa</strong>', classes: 'tab-tooltip'}"
                            :class="{'active-model': certificadoDados.modelo_id==model.id}"
                            v-on:click="certificadoDados.modelo_id = model.id">

                            <span class="fa-stack fa-lg">
                              <i class="fa fa-stack-2x fa-square"></i>
                              <i class="fa fa-stack-1x fa-inverse fa-image"></i>
                            </span>
                          </td>
                          <td>{{model.nome}}</td>
                          <td
                            v-if="hasVerso()"
                            style="max-width: 20px;"
                            v-tooltip.bottom="{content: '<strong>Imagem de fundo do verso</strong>', classes: 'tab-tooltip'}"
                            :class="{'active-model': certificadoDados.modelo_verso_id==model.id}"
                            v-on:click="certificadoDados.modelo_verso_id = model.id">

                            <span class="fa-stack fa-lg">
                              <i class="fa fa-stack-2x fa-square"></i>
                              <i class="fa fa-stack-1x fa-inverse fa-undo"></i>
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </label>
                </div>
                <div class="col-6 small-6 mid-4 big-3 background-item">
                  <a href="javascript:void(0)" class="new-image-button" v-on:click="showNewModelModal = !showNewModelModal">
                  <i class="fa fa-fw fa-plus-circle"></i>Adicionar novo modelo</a>
                </div>
              </div>
            </div>


            <!-- Assinaturas -->
            <div class="signatures col-12" v-show="activeTab==='signatures'">

              <h4 class="vp-h4 tab-title">Assinaturas</h4>

              <div class="row-flex">
                <div class="col-6 small-6 mid-4 big-3 signature-item" v-for="sign in signatures">

                    <a href="javascript:void(0)" class="btn vp-delete-btn vp-btn btn-sm remove-btn" v-on:click="removeSignature(sign.id)">
                      <i class="fa fa-fw fa-times"></i>
                    </a>
                    <input type="checkbox" name="assinaturas[]" :id="'assinatura_'+sign.id" :value="sign.id" v-model="certificadoDados.configs.assinaturas" v-on:click="handleSignatureLinks(sign)" />
                    <label :for="'assinatura_'+sign.id">
                      <div class="sg-item-wrapper" :class="{'active': isInListOfSigns(sign.id)}">
                        <img :src="url+sign.link">
                        <span>{{sign.nome}}</span>
                      </div>
                    </label>
                </div>
                <div class="col-6 small-6 mid-4 big-3 signature-item">
                  <a href="javascript:void(0)" class="new-image-button" v-on:click="showNewSignatureModal = !showNewSignatureModal"><i class="fa fa-fw fa-plus-circle"></i>Adicionar nova assinatura</a>
                </div>
              </div>
            </div>


            <!-- Configurações gerais do certificado -->
            <div class="general col-12" v-show="activeTab==='general'">

              <h4 class="vp-h4 tab-title">Configurações gerais</h4>

              <fieldset>
                <div class="form-group row-flex">
                  <label class="col-12 small-8 control-label">
                    Exibir verso do certificado?
                  </label>
                  <div class="col-12 small-4">
                    <div class="row-flex">
                      <span class="col-6">
                        <input type="radio" name="atividades_verso" id="atividades_verso_1" value="1" v-model="certificadoDados.configs.atividades_verso" />
                        <label for="atividades_verso_1">Sim</label>
                      </span>
                      <span class="col-6">
                        <input type="radio" name="atividades_verso" id="atividades_verso_0" value="0" v-model="certificadoDados.configs.atividades_verso" />
                        <label for="atividades_verso_0">Não</label>
                      </span>
                    </div>
                  </div>
                </div>

                <h4>Link de autenticação no rodapé</h4>

                <div class="form-group row-flex">
                  <label class="col-12 control-label">
                    Cor do texto:
                  </label>
                  <div class="col-12">
                    <compact-picker v-model="certificadoDados.configs.link_autenticacao.cor"></compact-picker>
                    <input type="text" class="form-control"
                        :name="'campo_'+certificadoDados.id"
                        placeholder="Insira um valor hexadecimal de cor. Ex.:'#000000'"
                        v-model="certificadoDados.configs.link_autenticacao.cor.hex"
                        disabled="disabled">
                  </div>
                </div>

                <div class="form-group row-flex">
                  <label class="col-12 control-label">
                    Posição do texto do rodapé:
                  </label>
                  <div class="col-12">
                    <div class="row-flex">
                      <span class="col-4">
                        <input type="radio" name="pos_link" id="pos_esquerda" value="esquerda" v-model="certificadoDados.configs.link_autenticacao.posicao" />
                        <label for="pos_esquerda">Esquerda</label>
                      </span>
                      <span class="col-4">
                        <input type="radio" name="pos_link" id="pos_centro" value="centro" v-model="certificadoDados.configs.link_autenticacao.posicao" />
                        <label for="pos_centro">Centro</label>
                      </span>
                      <span class="col-4">
                        <input type="radio" name="pos_link" id="pos_direita" value="direita" v-model="certificadoDados.configs.link_autenticacao.posicao" />
                        <label for="pos_direita">Direita</label>
                      </span>
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset v-if="certificadoDados.tipo==='evento'">
                <h4>Condições para o participante obter certificado do evento</h4>

                <div class="form-group row-flex">
                  <label class="col-12 small-8 control-label">
                    Obrigar presença do participante no evento
                  </label>
                  <div class="col-12 small-4">
                    <div class="row-flex">
                      <span class="col-6">
                        <input type="radio" name="obrigar_presenca" id="obrigar_presenca_1" value="1" v-model="certificadoDados.configs.evento_conditions.obrigar_presenca" />
                        <label for="obrigar_presenca_1">Sim</label>
                      </span>
                      <span class="col-6">
                        <input type="radio" name="obrigar_presenca" id="obrigar_presenca_0" value="0" v-model="certificadoDados.configs.evento_conditions.obrigar_presenca" />
                        <label for="obrigar_presenca_0">Não</label>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="form-group row-flex">
                  <label class="col-12 small-8 control-label">
                    Obrigar preenchimento de feedback
                  </label>
                  <div class="col-12 small-4">
                    <div class="row-flex">
                      <span class="col-6">
                        <input type="radio" name="obrigar_feedback" id="obrigar_feedback_1" value="1" v-model="certificadoDados.configs.evento_conditions.obrigar_feedback" />
                        <label for="obrigar_feedback_1">Sim</label>
                      </span>
                      <span class="col-6">
                        <input type="radio" name="obrigar_feedback" id="obrigar_feedback_0" value="0" v-model="certificadoDados.configs.evento_conditions.obrigar_feedback" />
                        <label for="obrigar_feedback_0">Não</label>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="form-group row-flex">
                  <label class="col-12 small-8 control-label">
                    Obrigar presença mínima nas atividades
                  </label>
                  <div class="col-12 small-4">
                    <div class="row-flex">
                      <span class="col-6">
                        <input type="radio" name="obrigar_presenca_minima_atividades" id="obrigar_presenca_minima_atividades_1" value="1" v-model="certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades" />
                        <label for="obrigar_presenca_minima_atividades_1">Sim</label>
                      </span>
                      <span class="col-6">
                        <input type="radio" name="obrigar_presenca_minima_atividades" id="obrigar_presenca_minima_atividades_0" value="0" v-model="certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades" />
                        <label for="obrigar_presenca_minima_atividades_0">Não</label>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="form-group row-flex" v-if="certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades==='1'">
                  <label class="col-12 small-8 control-label">
                    Quantos minutos totais o participante deverá ter, somando a presença em todas as atividades?
                  </label>
                  <div class="col-12 small-4">
                    <input type="text" class="form-control"
                        name="minutos_presenca_minima_atividades"
                        placeholder=""
                        v-model="certificadoDados.configs.evento_conditions.minutos_presenca_minima_atividades">
                  </div>
                  <div class="col-12">
                    <p class="warning-message"><strong>Por exemplo:</strong> o participante deverá ter assistido no mínimo 2 horas de atividades (120 minutos) para retirar o certificado.</p>
                  </div>
                </div>
              </fieldset>

              <fieldset v-if="certificadoDados.tipo==='atividade'" class="activity-list">
                <h4>Atividades que utilizarão este certificado</h4>

                <div class="form-group row-flex">
                  <div class="col-12 small-6" v-for="atividade in activitiesOptions">
                    <input type="checkbox" name="atividades[]" :id="'atividade-'+atividade.id" :value="atividade.id" v-model="activitiesSelected" :checked="atividade.certificado===certificadoDados.id" v-on:change="handleActivityCheck(atividade)">
                    <label :for="'atividade-'+atividade.id">
                      {{atividade.nome}}
                      <small v-if="atividade.using_new_certificado && atividade.certificado!=certificadoDados.id"><br>(Utilizando o certificado <strong>'{{atividade.certificado_nome}}'</strong>)</small>
                    </label>
                  </div>
                  <div class="col-12" v-if="activitiesOptions.length===0">
                    Seu evento ainda não possui nenhuma atividade cadastrada. Clique <a :href="url+'admin/inscricao/atividades'" target="_blank">aqui</a> para cadastrar uma nova
                  </div>
                </div>
              </fieldset>
            </div>

            <!-- Buttons -->
            <div class="col-12">
              <div class="form-buttons">
                <div class="form-inline">
                  <h5>Informe o ID do congressista de exemplo (ou deixe em branco): <input type="text" v-model="id_exemplo" class="form-control" placeholder="ID Aleatório"></h5>
                </div>
                <input class="vp-btn vp-btn vp-edit-btn btn btn-lg" type="submit" value="Salvar">
                <a v-if="id!=0"  href="javascript:void(0)" class="btn vp-btn vp-action-btn btn-lg" v-on:click="baixarCertificado()">Exemplo</a>
                <router-link to="/" class="btn vp-ghost-btn vp-back-btn btn-lg">Voltar</router-link>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

    <!-- Modal de novo modelo -->
    <vodal :show="showNewModelModal" animation="flip" class="vodal-middle" @hide="showNewModelModal=false">
      <div class="vodal-content">
        <!-- Loader -->
        <!-- <div class="vodal-loading" v-if="modalLoading===true">
          <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </div> -->
        <!-- Heading -->
        <div class="vodal-heading">
          <h4 class="vp-h4">
            Adicionar novo modelo de certificado
          </h4>
        </div>
        <!-- Contents -->
        <div class="vodal-middle">
          <div class="form-group row-flex">
            <label class="col-12 control-label">
              <span style="color: red;">*</span>
              Escolha um nome para o modelo:
            </label>
            <div class="col-12">
              <input type="text" class="form-control"
                  :name="'campo_'+certificadoDados.id"
                  placeholder="Escolha um nome para identificar o certificado"
                  v-model="newModelData.nome">
            </div>
          </div>
          <div class="form-group row-flex">
            <label class="col-12 control-label">
              <span style="color: red;">*</span>
              Imagem do modelo:
            </label>
            <div class="col-12">
              <input type="file" id="new-model-input" @change="modelImageChanged">
            </div>
          </div>
          <button class="vp-btn btn btn-md" v-on:click="createNewModel()">Criar</button>
        </div>
        <!-- Footer -->
        <div class="vodal-footer">
          <a href="javascript:void(0)" class="vp-btn vp-flat-btn vp-edit-btn btn btn-md " v-on:click="showNewModelModal=false">Fechar</a>
        </div>
      </div>
    </vodal>


    <!-- Modal de nova assinatura -->
    <vodal :show="showNewSignatureModal" animation="flip" class="vodal-middle" @hide="showNewSignatureModal=false">
      <div class="vodal-content">
        <!-- Loader -->
        <!-- <div class="vodal-loading" v-if="modalLoading===true">
          <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </div> -->
        <!-- Heading -->
        <div class="vodal-heading">
          <h4 class="vp-h4">
            Adicionar nova assinatura
          </h4>
        </div>
        <!-- Contents -->
        <div class="vodal-middle">
          <div class="form-group row-flex">
            <label class="col-12 control-label">
              <span style="color: red;">*</span>
              Insira o nome completo do autor da assinatura:
            </label>
            <div class="col-12">
              <input type="text" class="form-control"
                  :name="'campo_'+certificadoDados.id"
                  placeholder="Nome do autor da assinatura"
                  v-model="newSignatureData.nome">
            </div>
          </div>
          <div class="form-group row-flex">
            <label class="col-12 control-label">
              <span style="color: red;">*</span>
              Imagem com a assinatura:
            </label>
            <div class="col-12">
              <input type="file" id="new-sign-input" @change="signatureImageChanged">
            </div>
          </div>
          <button class="vp-btn btn btn-md" v-on:click="createNewSignature()">Criar</button>
        </div>
        <!-- Footer -->
        <div class="vodal-footer">
          <a href="javascript:void(0)" class="vp-btn vp-flat-btn vp-edit-btn btn btn-md " v-on:click="showNewSignatureModal=false">Fechar</a>
        </div>
      </div>
    </vodal>


    <!-- Modal com pré-visualização -->
    <vodal :show="showPreviewModal" animation="flip" class="vodal-middle preview-vodal" :class="certificadoDados.configs.formato" @hide="showPreviewModal=false">
      <div class="vodal-content">
        <!-- Heading -->
        <div class="vodal-heading">
          <h4 class="vp-h4">
            Exemplo
          </h4>
        </div>
        <!-- Contents -->
        <div class="vodal-middle">
          <object :data="demoUrl" type="application/pdf" :width="canvasWidth" :height="canvasHeight">
            <a :href="demoUrl">{{demoUrl}}</a>
          </object>
        </div>
        <!-- Footer -->
        <div class="vodal-footer">
          <a href="javascript:void(0)" class="vp-btn vp-flat-btn vp-edit-btn btn btn-md " v-on:click="showPreviewModal=false">Fechar</a>
        </div>
      </div>
    </vodal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import vSelect from 'vue-select'
  import vTooltip from 'v-tooltip'
  import Vodal from 'vodal'
  import jsPDF from 'jspdf'
  import { Compact } from 'vue-color'
  import debounce from 'debounce'

  import "vodal/common.css"
  import "vodal/flip.css"
  import "vodal/slide-up.css"

  var defaultColorBlack = {
    hex: '#000000',
    hsl: {
      h: 0,
      s: 0,
      l: 0,
      a: 1
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    },
    rgba: {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    },
    a: 1
  }

  Vue.use(vTooltip)
  Vue.component(Vodal.name, Vodal)

  export default {
    name: 'certificado-editor',
    components: {
      vSelect,
      vTooltip,
      'compact-picker': Compact
    },
    data () {
      return {
        id: '0',
        scrolled: false,
        pageLoading: false,
        editor: {um: null,dois: null,tres: null,},
        editorContent: {um: null,dois: null,tres: null,},
        canvasLoading: true,
        models: [],
        id_exemplo: undefined,
        signatures: [],
        demoUrl: '',
        signatureLinks: [],
        certificadoDados: {
            nome: '',
            texto: 'Texto do certificado',
            configs: {
              formato: 'paisagem',
              textoColor: defaultColorBlack,
              // textoSize: '10',
              // textoFamily: 'Arial, Helvetica, sans-serif',
              assinaturas: [],
              atividades_verso: '0',
              use_margin: '0',
              link_autenticacao: {
                cor: defaultColorBlack,
                posicao: 'esquerda'
              },
              evento_conditions: {
                obrigar_presenca: '0',
                obrigar_feedback: '0',
                obrigar_presenca_minima_atividades: '0',
                minutos_presenca_minima_atividades: '0'
              }
            },
            tipo: 'evento',
            ativo: '1',
            modelo_id: '0',
            modelo_verso_id: '0',
        },
        camposForm: [],
        trabalhoForm: [],
        showNewModelModal: false,
        showNewSignatureModal: false,
        showPreviewModal: false,
        newModelData: {
          nome: '',
          file: null
        },
        newSignatureData: {
          nome: '',
          file: null
        },
        activitiesSelected: [],
        activitiesOptions: [],
        activeModelImage: '',
        previewOpen: true,
        activeTab: 'text',
        activeEventCertificate: '',
        activateFlag: false,
        eventCertificateActivation: false,
        openMoreTags: false,
        saved: false,
        options: {
          fontsize_formats: "11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 19pt 20pt 21pt 22pt 23pt 24pt 25pt 26pt 27pt 28pt 29pt 30pt 31pt 32pt 33pt 34pt 35pt 36pt",
          plugins: [
              "advlist autolink lists link charmap print preview hr anchor pagebreak",
              "searchreplace wordcount visualblocks visualchars code fullscreen",
              "insertdatetime media nonbreaking save table contextmenu directionality",
              "emoticons template paste textcolor colorpicker textpattern"
          ],
          font_formats: 'Algerian=algerian;Arial Narrow=arial narrow;Arial=arial,helvetica,sans-serif;Baskerville Old Face=baskerville old face;Bauhaus 93=bauhaus 93;Berlin San Fb=berlin san fb;Bockman Old Style=bockman old style;Bodoni Mt=bodoni mt;Broadway=broadway;Brush Script Mt=brush script mt;Calibri=calibri;Cambria=cambria;Colonna Mt=colonna mt;Comic Sans=comic sans,cursive;Copperplate Gothic Bold=copperplate gothic bold;Corbel=corbel;Courier New=courier new,courier,monospace;Elephant=elephant;Engravers Mt=engravers mt;Franklin Gothic Heavy=franklin gothic heavy;Frankruehl=frankruehl;Garamond=garamond;Harrington=harrington;Imprint Mt Shadow=imprint mt shadow;Kalinga=kalinga;Lao Ui=lao ui;Lucida Calligraphy=lucida calligraphy;Microsoft Sans Serif=microsoft sans serif;Segoe Ui=segoe ui;Stencil=stencil;Tahoma=tahoma;Times New Roman=times new roman,serif;Verdana=verdana',
          toolbar1: "styleselect | fontselect fontsizeselect | alignleft aligncenter alignright |  bold italic | undo redo",
          toolbar2: "",
          menubar: false
        }
      }
    },
    computed: {
      url: function () {
        return url
      },
      canvasHeight: function () {
        if (this.certificadoDados.configs.formato==='retrato') return 1122
        return 560//793
      },
      canvasWidth: function () {
        if (this.certificadoDados.configs.formato==='retrato') return 793
        return 793//1122
      },
      eid() {
        return eid
      }
    },
    created: function () {
      this.pageLoading = true
      window.addEventListener('scroll', this.handleScroll);
    },
    mounted: function () {
      let self = this
      this.urlAdmin = url;

      window.onbeforeunload = function() {
        if (!self.saved) {
          return 'Deseja realmente sair da página?';
        }
      };

      if(this.$route.params.id){
        this.id = this.$route.params.id
      }
      Promise.all([
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "models",
          method: "GET",
          id: null
        }),

        this.$http.post(url+'admin/includes/newApi.php', {
          type: "signatures",
          method: "GET",
          id: null
        }),
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "certificado_tags",
          eid: eid
        }),
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "lista_atividades_certificado",
          eid: eid
        }),
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "certificado_de_evento_ativo",
          eid: eid
        }),
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "trabalho_tags",
          eid: eid
        })
      ])
      .catch(err => {
        swal(
          "Houve um erro.",
          "Verifique a conexão com a internet e tente novamente",
          "error"
        )
      })
      .then(resp => {
        this.models = resp[0].data
        // acrescenta o modelo 0, que é sem imagem
        let semImagem = {
          id: 0,
          link: undefined,
          nome: 'Sem Imagem'
        }
        this.models.unshift(semImagem)

        this.signatures = resp[1].data
        this.camposForm = resp[2].data
        this.activitiesOptions = resp[3].data
        this.trabalhoForm = resp[5].data

        if(resp[4].data && resp[4].data !== false) {
          this.activeEventCertificate = resp[4].data.id
        }
        else {
          this.activeEventCertificate = '0'
        }

        for (let i = 0; i < this.activitiesOptions.length; i++) {
          if (this.activitiesOptions[i].certificado===this.id && this.id!=='0'){
            this.activitiesSelected.push(this.activitiesOptions[i].id)
          }
        }

        if (this.id > 0) {
          this.getCertificadoDados()
        }
        else {
          this.eventCertificateActivation = true
        }
        this.pageLoading = false;
      })
    },
    destroyed: function () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      activeTab(val, prev) {
        if(val == 'text') {
          Vue.set(this.editorContent, 'um', this.certificadoDados.texto)
        }
        else if(val == 'text_verso') {
          Vue.set(this.editorContent, 'um', this.certificadoDados.verso_temAtividades)
          Vue.set(this.editorContent, 'dois', this.certificadoDados.verso_semAtividades)
          Vue.set(this.editorContent, 'tres', this.certificadoDados.verso_rodape)
        }
      },
      editor: {
        deep: true,
        handler(val, prev) {
          if(prev.um != null) {
            if(this.activeTab == 'text') {
              this.certificadoDados.texto = this.editor.um
            }
            else if(this.activeTab == 'text_verso') {
              this.certificadoDados.verso_temAtividades = this.editor.um
              this.certificadoDados.verso_semAtividades = this.editor.dois
              this.certificadoDados.verso_rodape = this.editor.tres
            }
          }
        },
      },
    },
    methods: {
      hasVerso() {
        // é evento
        // e o verso está ativado
        try {
          return this.certificadoDados.configs.atividades_verso != '0';
        } catch(e) {
          return false;
        }
      },
      padraoVerso() {
        if(window.confirm('Essa ação substituirá o texto atual do verso do certificado por um padrão. Deseja continuar?')) {
          let padrao = {
            um: `<p>Se&ccedil;&atilde;o destinada a tabela de atividades</p>\n<p style="text-align: center;"><strong>{tabelaAtividades}</strong></p>\n<p>Texto ap&oacute;s a tabela</p>\n`,
            dois: `<p>O congressista n&atilde;o participou de atividades</p>\n`,
            tres: `<p>Texto do rodap&eacute;</p>\n<p>Autentica&ccedil;&atilde;o online em {codigoLink}, c&oacute;digo {codigo}</p>\n<p>{codigoTexto}</p>\n`,
          };
          if(this.certificadoDados.tipo!=='evento') {
            padrao = {
              um: `<p>Padrão do verso do certificado de {nome}</p>\n`,
              dois: `\n`,
              tres: `<p>Texto do rodap&eacute;</p>\n<p>Autentica&ccedil;&atilde;o online em {codigoLink}, c&oacute;digo {codigo}</p>\n<p>{codigoTexto}</p>\n`,
            };
          }
          // preciso atualizar o elemento
          // então, atualizo ele duas vezes
          // isso acontece pq em :content=
          // não muda se eu clicar duas vezes no botão
          for(let i of ['um', 'dois', 'tres']) {
            this.editorContent[i] = ''
            this.editor[i] = ''
            Vue.nextTick(() => {
              this.editorContent[i] = padrao[i]
              this.editor[i] = padrao[i]
            })
          }
        }
      },
      draw: async function (canvas, loaderControl) {
        this.canvasLoading = true
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "certificado_demo"
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          this.demoUrl = res.data
          this.canvasLoading = false
        })
        return;
        // Get canvas context
        let self = this
        let {certificadoDados, models, signatureLinks} = this
        let ctx = canvas.getContext("2d")
        let cw = canvas.width
        let ch = canvas.height

        let initX = 0 // Posição horizontal onde começa a desenhar o certificado
        let initY = 0 // Posição vertical onde começa a desenhar o certificado

        // Se usar margem na configuração, redefine as dimensões de posições iniciais e finais do certificado
        if (certificadoDados.configs.use_margin==='1') {
          initX = 0.075*cw/2
          initY = 0.075*cw/2
          cw = cw - 0.075*cw
          ch = ch - 0.075*cw
        }

        // Signatures definitions
        let signsCount = signatureLinks.length   // Quantidade de assinaturas escolhidas
        let signGroupPosY = initY + ch * 0.66666   // Posição vertical do grupo com todas as assinaturas / Margem no topo de 60%
        let signGroupPosX = initX + cw * 0.1   // Posição horizontal do grupo com todas as assinaturas / Margem na direita de 10%
        let signsWidth = cw * 0.15   // Largura de uma assinatura fixada em 15%
        let signsHeight = cw * 0.075   // Altura de uma assinatura fixada em 7.5% da largura

        let signsPerRow = []   // Array armazenando quantas assinaturas vai possuir em cada linha (Só vai possuir uma segunda linha se tiver mais que 4 assinaturas)
        let signSpaceWidth = 0   // Tamanho (largura) da 'div' imaginária que contem uma assinatura. As imagens, textos e linha serão adicionadas e centralizadas dentro dessa 'div'
        if(signsCount<=4) {
          signsPerRow = [signsCount, 0]
          signSpaceWidth = (cw * 0.8) / signsCount
          signGroupPosY = signGroupPosY + signsHeight
        }
        else {
          signsPerRow = [3, signsCount-3]
          signSpaceWidth = (cw * 0.8) / 3
        }
        let signsMargin = (signSpaceWidth - signsWidth) / 2   // Tamanho utilizado para centralizar a assinatura dentro da 'div' signSpaceWidth

        // Text definitions
        let textStartX = initX + cw * 0.075;   // Posição horizontal de onde começa a desenhar o texto / Margem no topo de 15%
        let textStartY = initY + ch * 0.075;   // Posição vertical de onde começa a desenhar o texto /Margem na esquerda de 33.33%


        // Se o usuário tiver pulado espaços para alinhar verticalmente, refazer o cálculo da posição vertical contando a quantidade de '<p></p>' na string
        //textStartY = textStartY + ((certificadoDados.texto.split('<p></p>').length - 1) * 16)


        // Largura do espaço de texto (necessário para alinhamento de texto)
        let textWidth = Math.round(cw - (2 * (textStartX - initX)))


        // Autentication code definitions
        let autenticacaoX = 0.00608*canvas.width   // Margem na esquerda de 0,6%
        let autenticacaoY = canvas.height - 0.01825*canvas.width   // Posição do link de autenticação na base da página
        let autenticacaoText

        // Promises das imagens
        let promisses = []
        let images = []

        // Create background image
        let imgBg = null
        /*imgBg.crossOrigin = "anonymous"*/

        if(certificadoDados.modelo_id >0 ) {
          imgBg = new Image ();
          // Acha a imagem do modelo dado o ID escolhido no certificado
          let temp = models.filter(function ( obj ) {
                      return obj.id === certificadoDados.modelo_id
                    })[0]
          imgBg.src = url+temp.link
          //imgBg.crossOrigin = 'Anonymous'
          imgBg = await new Promise((resolve, reject) => {
            imgBg.onload = (resp) => {
              resolve(imgBg)
            }
            imgBg.onerror = (err) => {
              reject(err)
            }
          })
        }

        for(let i = 0; i < signsCount; i++) {

          let tempImage = new Image()
          /*tempImage.crossOrigin = "anonymous"*/
          tempImage.src = url+signatureLinks[i].link
          tempImage.alt = signatureLinks[i].nome

          promisses.push(new Promise((resolve, reject) => {
            tempImage.onload = (resp) => {
              resolve(tempImage)
            }
            tempImage.onerror = (err) => {
              reject(err)
            }
          }))
        }

        let textData = '<svg xmlns="http://www.w3.org/2000/svg" width="'+textWidth+'">' +
           '<foreignObject width="100%" height="100%">' +
           '<div xmlns="http://www.w3.org/1999/xhtml" style="font-family: Arial, sans-serif; color: ' + certificadoDados.configs.textoColor.hex + '; ' + (certificadoDados.configs.use_margin==='1' ? 'font-size: 0.925em;' : '') + '">' +
             certificadoDados.texto +
           '</div>' +
           '</foreignObject>' +
           '</svg>';

        let DOMURL = window.URL || window.webkitURL || window;

        let textImg = new Image();
        let textSvg = new Blob([textData], {type: 'image/svg+xml'});
        let textUrl = DOMURL.createObjectURL(textSvg);


        // Clear the canvas
        ctx.clearRect(0,0,canvas.width,canvas.height);
        // Preencher canvas com fundo branco
        ctx.beginPath()
        ctx.rect(0,0,canvas.width,canvas.height)
        ctx.fillStyle = 'white'
        ctx.fill();
        ctx.closePath()
        // Bg do certificado
        if(imgBg) {
          ctx.drawImage(imgBg, initX, initY, cw, ch);
        }

        Promise.all(promisses).then(function (response) {

          textImg.onload = function() {
            ctx.drawImage(textImg, textStartX, textStartY);
            DOMURL.revokeObjectURL(textUrl)
          }

          textImg.src = textUrl

          // Link de autenticação
          ctx.fillStyle = certificadoDados.configs.link_autenticacao.cor.hex
          ctx.font = '14px Arial'
          autenticacaoText = 'Autenticação online em '+url+'certificados/autenticar, codigo xxxxxx'
          if (certificadoDados.configs.link_autenticacao.posicao==='centro') {
            autenticacaoX = (canvas.width - ctx.measureText(autenticacaoText).width)/2 //Mede tamanho do texto e define margem na esquerda para centralizar o texto
          }
          else if (certificadoDados.configs.link_autenticacao.posicao==='direita'){
            autenticacaoX = canvas.width - ctx.measureText(autenticacaoText).width - (0.00608*canvas.width) // Mede tamanho do texto e define posição horizontal no canvas, adicionando 0,6% de margem na direita
          }
          ctx.fillText(autenticacaoText, autenticacaoX, autenticacaoY);

          // Assinaturas do certificado
          let signPosX = 0
          let signPosY = 0
          for (let j = 0; j < signsCount; j++) {
            // X e Y utilizados quando o certificado possui no maximo 4 assinaturas
            signPosX = signGroupPosX + (j * signSpaceWidth) + signsMargin
            signPosY = signGroupPosY

            // X e Y aplicados nas assinaturas da 2ª 'linha' quando o certificado possui mais que 4 assinaturas
            if(signsPerRow[1]!==0 && j > 2) {
              signPosX = signGroupPosX + ((j%3) * signSpaceWidth) + signsMargin
              signPosY = signGroupPosY + signsHeight + (0.025*canvas.width)
            }
            // X e Y aplicados nas 4ª e 5ª assinaturas escolhidas, quando o certificado possui exatamente 5 assinaturas
            if(signsPerRow[1]===2 && j > 2) {
              signPosX = signGroupPosX + ((j%3) * signSpaceWidth) + signsMargin + (signSpaceWidth / 2)
            }
            ctx.drawImage(response[j], signPosX, signPosY, signsWidth, signsHeight);
            ctx.beginPath()
            ctx.moveTo(signPosX,signPosY+signsHeight);
            ctx.lineTo(signPosX+signsWidth,signPosY+signsHeight);
            ctx.lineWidth = 2
            ctx.font = 'bold 14px Arial'
            ctx.fillStyle = "#000"
            ctx.fillText(response[j].alt, signPosX+((signsWidth/2) - (ctx.measureText(response[j].alt).width/2)), signPosY+signsHeight+16); //63.8 = tamanho da fonte no nome do autor da assinatura
            ctx.stroke();
            ctx.closePath();
          }
          if (loaderControl) {
            setTimeout(function () {
              self.canvasLoading = false
            }, 700)
          }
        })
        .catch(err => {
          if (loaderControl) {
            setTimeout(function () {
              self.canvasLoading = false
            }, 700)
          }
        })
        console.log('drawing'+(loaderControl ? ' preview 1' : ''))
      },
      handleScroll () {
        this.scrolled = window.scrollY > 300;
      },
      getCertificadoDados: function () {
        let self = this

        this.$http.post(url+'admin/includes/newApi.php', {
          type: "certificates",
          method: "GET",
          id: this.id
        })
        .then(resp => {
          self.certificadoDados = resp.data
          // o texto_verso
          // deve ser alterado para comAtividades, ...
          if('texto_verso' in self.certificadoDados) {
            let texto_verso = self.certificadoDados.texto_verso
            texto_verso = texto_verso.replace("\r", '')
            texto_verso = texto_verso.split("\n")
            let crop = (texto_verso, busca) => {
              let len = texto_verso.length
              let i = 0
              while(i < len) {
                if(texto_verso[i].indexOf(busca) != -1) {
                  break
                }
                i++
              }
              return [texto_verso.slice(0, i), texto_verso.slice(i+1, len)]
            };
            [texto_verso, self.certificadoDados.verso_rodape] = crop(texto_verso, '{rodape}');
            [texto_verso, self.certificadoDados.verso_semAtividades] = crop(texto_verso, '{semAtividades}');
            [texto_verso, self.certificadoDados.verso_temAtividades] = crop(texto_verso, '{temAtividades}');
            self.certificadoDados.verso_rodape = self.certificadoDados.verso_rodape.join("\n");
            self.certificadoDados.verso_semAtividades = self.certificadoDados.verso_semAtividades.join("\n");
            self.certificadoDados.verso_temAtividades = self.certificadoDados.verso_temAtividades.join("\n");
          }
          else {
            self.certificadoDados.verso_rodape = ''
            self.certificadoDados.verso_semAtividades = ''
            self.certificadoDados.verso_temAtividades = ''
          }

          if (!self.certificadoDados.configs) {
            self.certificadoDados.configs = {
              formato: 'paisagem',
              textoColor: defaultColorBlack,
              // textoSize: '10',
              // textoFamily: 'Arial, Helvetica, sans-serif',
              assinaturas: [],
              atividades_verso: '0',
              use_margin: '0',
              link_autenticacao: {
                cor: defaultColorBlack,
                posicao: 'esquerda'
              },
              evento_conditions: {
                obrigar_presenca: '0',
                obrigar_feedback: '0',
                obrigar_presenca_minima_atividades: '0',
                minutos_presenca_minima_atividades: '0'
              }
            }
          }

          let aux

          for (let i=0; i<self.certificadoDados.configs.assinaturas.length; i++) {
            aux = self.signatures.filter(function( obj ) {
              return obj.id == self.certificadoDados.configs.assinaturas[i];
            });
            self.signatureLinks.push(aux[0])
          }

          /* Deixar esses dois ifs enquanto tiver algum certificado com cor armazenada como string (Ex.: '#989898'). Se todos já estiverem com o formato Object de cores, REMOVER */
          if (typeof(self.certificadoDados.configs.textoColor)==='string') {
            self.certificadoDados.configs.textoColor = defaultColorBlack
          }
          if (typeof(self.certificadoDados.configs.link_autenticacao.cor)==='string') {
            self.certificadoDados.configs.link_autenticacao.cor = defaultColorBlack
          }

          self.editorContent.um = self.certificadoDados.texto
        })
      },
      baixarCertificado: async function () {
        this.pageLoading = true
        await this.submitCertificateData();
        this.pageLoading = true
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "certificado_demo",
          id: this.id,
          id_exemplo: this.id_exemplo
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          setTimeout(() => {
            this.pageLoading = false
            this.demoUrl = res
            this.showPreviewModal = true;
          }, 1000)
        })
        .catch(err => {
            this.pageLoading = false
        })
      },
      submitCertificateData: function (download) {
        let returnValue = null
        let method = ''
        let idUsed = ''
        let self = this

        if (this.certificadoDados.nome===''){
          swal("Erro", "Insira um nome que identifique o certificado", "error")
        }
        else {

          self.pageLoading = true

          if (self.id==='0') {
            method = 'POST'
          }
          else {
            method = 'PUT'
          }

          if (self.certificadoDados.tipo==='evento' && self.activeEventCertificate==='0') {
            self.certificadoDados.ativo = '1'
          }

          let verso = '';
          if(self.certificadoDados.verso_rodape || self.certificadoDados.verso_semAtividades || self.certificadoDados.verso_temAtividades) {
            verso = ['{temAtividades}', self.certificadoDados.verso_temAtividades, '{semAtividades}', self.certificadoDados.verso_semAtividades, '{rodape}', self.certificadoDados.verso_rodape].join("\n")
            console.log("verso:", verso);
          }

          return this.$http.post(url+'admin/includes/newApi.php', {
            type: "certificates",
            method: method,
            id: self.id,
            value: self.certificadoDados.nome,
            value2: self.certificadoDados.tipo,
            value3: self.certificadoDados.texto,
            value4: verso,
            value5: self.certificadoDados.configs,
            value6: self.certificadoDados.ativo,
            value7: self.certificadoDados.modelo_id,
            value8: self.certificadoDados.modelo_verso_id,
          })
          .then(resp => {
            if (method === 'POST' || self.id === '0') {
              idUsed = resp.data.id
            } else {
              idUsed = self.id
            }

            let promises = []
            if (self.certificadoDados.tipo==='atividade') {
              promises.push(
                this.$http.post(url+'admin/includes/newApi.php', {
                  type: "add_cert_to_activities",
                  id: idUsed,
                  value: self.activitiesSelected
                })
              )
            }

            if (typeof download === 'undefined') {
              if (self.eventCertificateActivation===true) {
                promises.push(
                  this.$http.post(url+'admin/includes/newApi.php', {
                    type: "activate_event_certificate",
                    id: idUsed,
                    eid: this.eid
                  })
                )
              }
            }
            else {
              console.log(download)
            }

            if (promises.length > 0) {
              Promise.all(promises)
              .then(resp => {
                self.pageLoading = false
                self.$toasted.show( 'Suas mudanças foram salvas com sucesso!', {
                  position: 'top-center',
                  duration: 3000,
                  onComplete: function () {
                    self.saved = true
                    self.closeEditor()
                  }
                })
                // swal({
                //   title: "Sucesso",
                //   text: "Suas mudanças foram salvas com sucesso!",
                //   type: "success",
                //   showConfirmButton: true
                // }, function () {
                //   self.saved = true
                //   self.closeEditor()
                // });

                self.activateFlag = false
                self.eventCertificateActivation = false
              })
              .catch(err => {
                self.pageLoading = false
                swal(
                  "Houve um erro.",
                  "Verifique a conexão com a internet e tente novamente",
                  "error"
                )
              })
            } else {
              self.pageLoading = false
              self.$toasted.show( 'Suas mudanças foram salvas com sucesso!', {
                position: 'top-center',
                duration: 3000,
                onComplete: function () {
                  self.saved = true
                  self.closeEditor()
                }
              })
              // swal({
              //   title: "Sucesso",
              //   text: "Suas mudanças foram salvas com sucesso!",
              //   type: "success",
              //   showConfirmButton: true
              // }, function () {
              //   self.saved = true
              //   self.closeEditor()
              // });

                self.activateFlag = false
                self.eventCertificateActivation = false
            }

            if (self.id==='0') {
              self.$router.push({ path: '/', params: { id: idUsed }})
            }
          })
        }
      },
      closeEditor: function () {
        this.$emit('exit');
      },
      handlePreview: function () {
        if (this.previewOpen===true) this.previewOpen=false
        else this.previewOpen=true
      },
      isInListOfSigns: function (id) {
        let pos = this.certificadoDados.configs.assinaturas.indexOf(id)
        if (pos === -1) return false
        return true
      },
      handleSignatureLinks: function (obj) {
        if (this.certificadoDados.configs.assinaturas.length > 6) {
          swal("Erro", "Você pode inserir no máximo 6 assinaturas em cada certificado", "error")
          this.certificadoDados.configs.assinaturas.pop()
        }
        else {
          let index = -1
          for(let i = 0; i < this.signatureLinks.length; i++) {
            if (this.signatureLinks[i].id == obj.id) {
              index = i
              break;
            }
          }
          if(index !== -1) {
            this.signatureLinks.splice(index, 1)
          }
          else {
            this.signatureLinks.push(obj)
          }
        }
      },
      removeActivityFromSelectionList: function (id) {
        let index = -1
        for(let i = 0; i < this.activitiesSelected.length; i++) {
          if (this.signatureLinks[i] == id) {
            index = i
            break;
          }
        }
        this.activitiesSelected.splice(index, 1)
      },
      handleActivityCheck: function (activity) {
        let self = this

        if (activity.using_new_certificado===true && activity.certificado_nome!==self.certificadoDados.nome) {
          swal({
            title: "Tem certeza disso?",
            text: "Esta atividade já está utilizando o certificado '"+activity.certificado_nome+"'. Você pretende mesmo alterar o certificado da atividade para o modelo '"+self.certificadoDados.nome+"'?",
            type: "warning",
            showCancelButton: true,
            cancelButtonText: "Não",
            confirmButtonText: "Sim, alterar!",
            confirmButtonColor: "#3498db",
            // closeOnConfirm: false
          }, function(isConfirm) {
            if(isConfirm) {
              activity.certificado_nome = self.certificadoDados.nome
              activity.certificado = self.certificadoDados.id

              self.$toasted.show( 'Certificado da atividade alterado!', {
                position: 'top-center',
                duration: 3000
              })
              // swal("Sucesso!","Certificado da atividade alterado!", "success")
            }
            else {
              self.removeActivityFromSelectionList(activity.id)
            }
          })
        }
        else {

        }
      },
      changeTab: function (value) {
        this.activeTab = value
      },
      handleCertificateStatus: function () {

        let self = this

        if (this.certificadoDados.tipo==='evento' && this.certificadoDados.ativo==='0' && this.activeEventCertificate!='0') {
          swal({
            title: 'Tem certeza?',
            text: 'Você só pode ter apenas UM certificado ativo por evento. Portanto, o certificado que está sendo utilizado atualmente será desativado para que este seja ativado. Deseja mesmo prosseguir?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim, alterar',
            confirmButtonColor: '#f39c12',
            // closeOnConfirm: false
          }, function () {
            self.certificadoDados.ativo = '1'
            self.activateFlag = true
            self.eventCertificateActivation = true
            // swal('Em status de espera', 'O processo está em espera. Para finalizar a mudança, salve as alterações do certificado', 'success')

            self.$toasted.show( 'Para finalizar a mudança, salve as alterações do certificado', {
              position: 'top-center',
              duration: 3000
            })
          })
        }
        else {
          if (this.certificadoDados.ativo==='0') {
            this.certificadoDados.ativo='1'
          }
          else this.certificadoDados.ativo='0'

          this.activateFlag = true
          // swal('Em status de espera', 'O processo está em espera. Para finalizar a mudança, salve as alterações do certificado', 'success')

          self.$toasted.show( 'Para finalizar a mudança, salve as alterações do certificado', {
            position: 'top-center',
            duration: 3000
          })
        }
      },
      /* Models & Signatures */
      getCertificadoModels: function () {
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "models",
          method: "GET",
          id: null
        })
        .then(resp => {
          this.models = resp.data
        })
      },
      getSignatures: function () {
        this.$http.post(url+'admin/includes/newApi.php', {
          type: "signatures",
          method: "GET",
          id: null
        })
        .then(resp => {
          this.signatures = resp.data
        })
      },
      createNewModel: function () {
        let self = this
        let formData = new FormData();

        if (this.newModelData.nome === '') {
          swal('Erro', 'Preencha um nome para identificar o modelo', 'error')
        }
        else if (this.newModelData.file === null) {
          swal('Erro', 'Escolha um arquivo de imagem para o modelo', 'error')
        }
        else {
          self.pageLoading = true
          formData.append('type', 'models');
          formData.append('method', 'POST');
          formData.append('value', this.newModelData.nome);
          formData.append('imagem', this.newModelData.file);

          this.$http.post(url+'admin/includes/newApi.php',
            formData
          )
          .then(resp => {
            if (typeof(resp.data)==='object') {
              // swal("Sucesso", "O modelo de imagem de fundo foi adicionado com sucesso e está disponível para uso", "success")

              self.$toasted.show( 'O modelo de imagem de fundo foi adicionado com sucesso e está disponível para uso', {
                position: 'top-center',
                duration: 3000
              })
              self.newModelData.nome = ''
              self.newModelData.file = null
              self.getCertificadoModels()
              self.certificadoDados.modelo_id = resp.data.id
              self.showNewModelModal = false
              self.pageLoading = false
              document.getElementById("new-model-input").value = ""
            }
            else if(resp.data==='Nome is missing.') {
              swal('Erro', 'Preencha um nome para identificar o modelo', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
            else if (resp.data==='Imagem is missing.') {
              swal('Erro', 'Insira uma imagem para o modelo', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
            else {
              swal('Erro', 'Ocorreu algum erro', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
          })
        }
      },
      createNewSignature: function () {
        let self = this
        let formData = new FormData();

        if (this.newSignatureData.nome === '') {
          swal('Erro', 'Preencha um nome para identificar o autor da assinatura', 'error')
        }
        else if (this.newSignatureData.file === null) {
          swal('Erro', 'Escolha um arquivo de imagem para representar a assinatura', 'error')
        }
        else {
          self.pageLoading = true
          formData.append('type', 'signatures');
          formData.append('method', 'POST');
          formData.append('value', this.newSignatureData.nome);
          formData.append('imagem', this.newSignatureData.file);

          this.$http.post(url+'admin/includes/newApi.php',
            formData
          )
          .then(resp => {
            if (typeof(resp.data)==='object') {
              // swal("Sucesso", "A assinatura foi adicionada ao banco de dados com sucesso e está disponível para uso nos certificados", "success")

              self.$toasted.show( 'A assinatura foi adicionada ao banco de dados com sucesso e está disponível para uso nos certificados', {
                position: 'top-center',
                duration: 3000
              })
              self.newSignatureData.nome = ''
              self.newSignatureData.file = null
              self.getSignatures()
              self.showNewSignatureModal = false
              self.pageLoading = false
              document.getElementById("new-sign-input").value = ""
            }
            else if(resp.data==='Nome is missing.') {
              swal('Erro', 'Preencha um nome para identificar o autor da assinatura', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
            else if (resp.data==='Imagem is missing.') {
              swal('Erro', 'Escolha um arquivo de imagem para representar a assinatura', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
            else {
              swal('Erro', 'Ocorreu algum erro', 'error')
              self.showNewModelModal = false
              self.pageLoading =false
            }
          })
        }
      },
      modelImageChanged(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.newModelData.file = files[0]
        //this.createImage(files[0]);
      },
      signatureImageChanged(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.newSignatureData.file = files[0]
        //this.createImage(files[0]);
      },
      removeModel: function (id) {
        let self = this

        if(self.models.length > 1) {
          swal({
            title: "Tem certeza?",
            text: "Deseja mesmo remover este modelo do seu banco de imagens? Esta ação não poderá ser revertida.",
            type: "warning",
            showCancelButton: true,
            cancelButtonText: "Não",
            confirmButtonText: "Sim, remover!",
            confirmButtonColor: "#e74c3c",
            // closeOnConfirm: false
          }, function(isConfirm) {
            if(isConfirm) {
              self.pageLoading = true

              self.$http.post(url+'admin/includes/newApi.php', {
                type: "models",
                method: "DELETE",
                id: id
              })
              .then(resp => {
                self.getCertificadoModels()
                if(self.certificadoDados.modelo_id===id) {
                  self.certificadoDados.modelo_id = '0'
                }
                self.pageLoading = false
                // swal("Sucesso", "O modelo de certificado foi removido com sucesso", "success")

                self.$toasted.show( 'O modelo de certificado foi removido com sucesso', {
                  position: 'top-center',
                  duration: 3000
                })
              })
            }
          })
        }
        else {
          swal("Erro", "Você deve ter ao menos um modelo no banco de imagens para ser utilizado", "error")
        }
      },
      removeSignature: function (id) {
        let self = this

        swal({
          title: "Tem certeza?",
          text: "Deseja mesmo remover esta assinatura do seu banco de imagens? Esta ação não poderá ser revertida.",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Não",
          confirmButtonText: "Sim, remover!",
          confirmButtonColor: "#e74c3c",
          // closeOnConfirm: false
        }, function(isConfirm) {
          if(isConfirm) {
            self.pageLoading = true

            self.$http.post(url+'admin/includes/newApi.php', {
              type: "signatures",
              method: "DELETE",
              id: id
            })
            .then(resp => {
              let index=-1
              for(let i = 0; i < self.signatureLinks.length; i++) {
                if (self.signatureLinks[i].id == id) {
                  index = i
                  break;
                }
              }
              if(index !== -1) {
                self.signatureLinks.splice(index, 1)
              }
              index = self.certificadoDados.configs.assinaturas.indexOf(id)
              if(index !== -1) {
                self.certificadoDados.configs.assinaturas.splice(index, 1)
              }

              self.getSignatures()
              self.pageLoading = false
              //swal("Sucesso", "A assinatura foi removida com sucesso", "success")

              self.$toasted.show( 'A assinatura foi removida com sucesso', {
                position: 'top-center',
                duration: 3000
              })
            })
          }
        })
      }
    }
  }
</script>


<style type="text/css" scoped>

  /* GENERALS */
    .vp-module-heading small {
      text-transform: none;
      display: block;
      margin-top: 10px;
    }
    .vp-module-heading small .btn {
      color: #FFF;
      background-color: #34495e;
      width: auto;
    }
    .vp-module-heading small.ativo {
      color: #2ecc71;
    }
    .vp-module-heading small.n-ativo {
      color: #e74c3c;
    }
    @media (min-width: 992px) {
      .vp-module-heading small {
        display: inline-block;
      }
    }
    .vc-compact {
      width: 245px !important;
    }
  /* ./GENERALS */


  /* LOADERS */
    #page-loading {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0,0,0,0.75);
      z-index: 100001;
      color: #FFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
    #page-loading > i {
      color: #2ecc71;
    }
    #page-loading > span {
      padding-top: 15px;
    }
    .preview-holder > .content > .preview-wrapper > .canvas-loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #FFF;
    }
    .preview-holder > .content > .preview-wrapper > .canvas-loader > i {
      color: #3498db;
    }
  /* ./LOADERS */


  /* TABS */
    ul.control-tabs {
      padding: 0;
      margin: 0;
      margin-bottom: 10px;
      list-style: none;
      display: flex;
      flex-direction: row;
    }
    ul.control-tabs li {
      flex-basis: 50%;
      text-align: center;
      font-size: 24px;
      border-radius: 5px 5px 0 0;
      border: 1px solid #eaeaea;
      background-color: #f1c40f;
      transition: all 0.2s ease-in;
    }
    ul.control-tabs li:hover {
      background-color: #f39c12;
    }
    ul.control-tabs li.active {
      border-bottom-width: 0px;
      border-color: #eaeaea;
      background-color: #FFF;
    }
    ul.control-tabs li a {
      color: #FFF;
      padding: 5px 10px;
      display: inline-block;
      height: 100%;
      width: 100%;
    }
    ul.control-tabs li.active a {
      color: #f39c12;
    }
    ul.control-tabs li a span {
      display: block;
      font-size: 10px;
    }
    .active-model {
      color: #1E90FF;
    }
    .tab-title {
      color: #2980b9;
      font-weight: 700;
      text-transform: uppercase;
    }
    ul.control-tabs {
      width: 50%;
      padding: 0 10px;
    }
    @media (max-width: 991px) {
      ul.control-tabs {
        width: 100%;
        padding: 0 10px;
      }
    }/*
    @media (min-width: 992px) {
      ul.control-tabs {
        flex-direction: column;
        width: 45px;
        position: absolute;
      }
      ul.control-tabs:not(.scrolled) {
        left: -45px;
      }
      #main-content ul.control-tabs.scrolled {
        left: 270px;
      }
      ul.control-tabs.scrolled {
        position: fixed;
        top: 120px;
      }
      ul.control-tabs li {
        padding: 5px;
        border-radius: 5px 0 0 5px;
        border-right-width: 0;
      }
      ul.control-tabs li.active {
        width: 46px;
        margin-right: -1px;
        border-bottom-width: 1px;
      }
      ul.control-tabs li a {
        padding: 5px 0;
      }
      ul.control-tabs li.active a {
      }
      ul.control-tabs li a span {
        display: none;
      }
      form .cert-tab-content {
        position: relative;
        border: 1px solid #eaeaea;
        margin-right: 0;
        border-radius: 5px;
        padding-top: 5px;
        padding-bottom: 15px;
        box-shadow: 0 0 10px -5px rgba(0,0,0,1);
      }
      .certificado-editor form {
        padding-left: 60px;
      }
    }
  /* ./TABS */


  /* PREVIEW */
    object {
      max-width: 100%;
    }
    object {
      transform-origin: left top;
      transition: transform 0.2s ease-in;
    }
    .preview-holder {
      position: fixed;
      background-color: rgba(0,0,0,0.75);
      padding: 10px 15px;
      border-radius: 5px 0 0 5px;
      transition: all 0.3s ease-out;
    }
    .preview-holder > .content {
      position: relative;
    }
    .preview-holder h4 {
      margin-top: 0;
      color: #FFF;
    }
    .preview-holder small {
      color: #FFF;
      display: block;
      text-align: center;
      margin-top: 5px;
    }
    .preview-holder.paisagem {
      top: 185px;
      right: -351px;
      height: 300px;
      width: 381px
    }
    .preview-holder.retrato {
      top: 155px;
      right: -298px;
      height: 471.5px;
      width: 328px
    }
    .preview-holder.paisagem > .content > .preview-wrapper {
      width: 351px;
      height: 248px;
    }
    .preview-holder.retrato > .content > .preview-wrapper {
      width: 298px;
      height: 421.5px;
    }
    .preview-holder.open {
      right: 0 !important;
    }
    .preview-holder.paisagem object {
      transform: scale(0.441);
    }
    .preview-holder.retrato object {
      transform: scale(0.38);
    }
    .preview-holder > .content > .preview-wrapper {
      overflow: hidden;
      position: relative;
    }
    .preview-holder > .content > .preview-wrapper > .link-mask {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #FFF;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
    .preview-holder > .content > .preview-wrapper > .link-mask:hover {
      opacity: 0.75;
    }
    .preview-holder > .content > .preview-wrapper > .link-mask > a {
      width: 100%;
      height: 100%;
      font-weight: 700;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .preview-holder > .content > a.handle-preview {
      position: absolute;
      top: 200px;
      left: -55px;
      font-size: 20px;
    }
    .preview-holder > .content > a.handle-preview .fa-circle {
      color: #34495e;
      top: 2px;
      font-size: 1.95em;
    }
    .preview-holder > .content > a.handle-preview .fa-inverse {
      color: #ecf0f1;
      transition: all 0.2s linear
    }
    @media (max-width: 450px) {
      .preview-holder.paisagem.open > .content > a.handle-preview {
        left: -25px;
      }
    }
    @media (min-width: 768px) {
      .preview-holder.paisagem {
        height: 315px;
      }
    }
    @media (max-width: 991px) {
      .preview-holder.paisagem > .content > a.handle-preview {
        top: 120px;
      }
    }
    @media (min-width: 992px) {
      .preview-holder.paisagem object {
        transform: scale(0.55);
      }
      .preview-holder.retrato object {
        transform: scale(0.44);
      }
      .preview-holder.paisagem > .content > .preview-wrapper {
        width: 437.25px;
        height: 309px;
      }
      .preview-holder.retrato > .content > .preview-wrapper {
        width: 347.5px;
        height: 491.5px;
      }
      .preview-holder > .content > a.handle-preview {
        transition: top 0.3s ease-in;
      }
      .preview-holder.paisagem > .content > a.handle-preview {
        top: 160px;
      }
      .preview-holder.paisagem {
        top: 125px;
        right: -440px;
        height: 375px;
        width: 470px
      }
      .preview-holder.retrato {
        top: 85px;
        right: -345px;
        height: 555px;
        width: 375px
      }
    }
  /* ./PREVIEW */


  /* FORM */
    fieldset {
      border: 1px solid #cecece;
      border-radius: 5px;
      padding: 10px 15px;
      margin-bottom: 10px;
      background-color: #f7f7f7;
    }
    input + label {
      font-weight: 400;
    }
    .warning-message {
      margin-top: 10px;
      margin-bottom: -10px;
      padding: 10px;
      background-color: #ffefc4;
      border-radius: 3px;
      border: 1px solid #f1c40f;
    }

    .activity-list .form-group > div {
      margin-bottom: 10px;
    }
    .activity-list label {
      display: inline;
    }
    small.attention {
      color: #e74c3c;
    }
    .form-buttons {
      border-top: 1px solid #eaeaea;
      padding-top: 15px;
      margin-top: 10px;
    }
  /* ./FORM */


  /* IMAGE LABELS */
    form .background .background-item {
      margin-bottom: 15px;
      position: relative
    }
    form .background .background-item .remove-btn {
      position: absolute;
      top: 10px;
      left: 25px;
      font-size: 16px;
      display: none;
    }
    form .background .background-item:hover .remove-btn {
      display: block;
    }
    form .background .bg-item-wrapper {
      width: 100%;
      height: 100%;
      border: 2px solid #8c8c8c;
      border-radius: 3px;
      padding: 10px;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    form .background .bg-item-wrapper.active {
      border-color: #3498db;
    }
    form .background label .bg-item-wrapper.active  {
      color: #FFF;
      background-color: rgba(52, 152, 219, 0.75);
    }
    form .background input {
      display: none;
    }
    form .background label {
      width: 100%;
      height: 100%;
      margin: 0;
    }
    form .background label > .bg-item-wrapper > img {
      width: 100%;
      padding-bottom: 10px;
      margin: auto;
    }
    form .background label > .bg-item-wrapper > span {
      margin-top: auto;
      font-weight: 400;
      font-size: 16px;
    }
    form .background label > .bg-item-wrapper.active > span {
      font-weight: 700;
    }

    form .signatures .signature-item {
      margin-bottom: 15px;
      position: relative;
    }
    form .signatures .signature-item .remove-btn {
      position: absolute;
      top: 10px;
      left: 25px;
      font-size: 16px;
      display: none;
    }
    form .signatures .signature-item:hover .remove-btn {
      display: block;
    }
    form .signatures label {
      width: 100%;
      height: 100%;
      margin: 0;
    }
    form .signatures .sg-item-wrapper {
      width: 100%;
      height: 100%;
      border: 2px solid #8c8c8c;
      border-radius: 3px;
      padding: 10px;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    form .signatures .sg-item-wrapper.active {
      border-color: #3498db;
    }
    form .signatures label .sg-item-wrapper.active {
      color: #FFF;
      background-color: rgba(52, 152, 219, 0.75);
    }
    form .signatures input {
      display: none;
    }
    form .signatures label .sg-item-wrapper {
      width: 100%;
      margin: 0;
    }
    form .signatures label > .sg-item-wrapper > img {
      width: 100%;
      padding-bottom: 10px;
    }
    form .signatures label > .sg-item-wrapper > span {
      margin-top: auto;
      font-weight: 400;
      font-size: 16px;
    }
    form .signatures label > .sg-item-wrapper.active > span {
      font-weight: 700;
    }
    .new-image-button {
      height: 100%;
      width: 100%;
      display: inline-block;
      display: flex;
      flex-direction: column;
      background-color: #1abc9c;
      border-radius: 3px;
      justify-content: center;
      align-items: center;
      color: #FFF;
      font-size: 16px;
      font-weight: 400;
      padding: 15px;
      min-height: 150px;
      text-align: center;
    }
    .new-image-button > i {
      font-size: 64px;
    }
  /* ./IMAGE LABELS */


  /* TAG TABLE */
    .tables .vp-flextable.alternate .vp-ft-row.closeable {
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s linear;
    }
    .tables .vp-flextable.alternate .vp-ft-row.closeable.expand {
      max-height: 100px;
    }
    .open-more-tags-btn {
      background-color: #ecf0f1;
      padding: 10px;
      text-align: center;
      color: #34495e;
      font-weight: 700;
    }
    .open-more-tags-btn i {
      font-size: 20px;
      display: block;
    }
  /* ./TAG TABLE */


  .vp-flextable {
    margin-bottom: 15px;
  }
</style>

<style type="text/css">
  /* PREVIEW VODAL */
    .preview-vodal .vodal-dialog {
      top: 80px;
    }
    .preview-vodal .vodal-dialog .vodal-heading > h4 {
      margin-bottom: 5px;
    }
    .preview-vodal .vodal-dialog .vodal-middle {
      text-align: center;
    }
    .preview-vodal.paisagem .vodal-dialog {
      width: 95vw !important;
      height: 75vw !important;
      max-width: 800px;
      max-height: 625px;
    }
    .preview-vodal.paisagem .vodal-dialog canvas {
      width: 90vw;
      max-width: 100%;
    }
    .preview-vodal.retrato .vodal-dialog {
      width: calc(95vh - 100px * 0.707) !important;
      height: calc(95vh - 60px) !important;
    }
    .preview-vodal.retrato .vodal-dialog object {
      height: calc(100vh - 180px);
      max-width: 100%;
    }
  /* ./PREVIEW VODAL */
#outerContainer #mainContainer div.toolbar {
  display: none !important; /* hide PDF viewer toolbar */
}
#outerContainer #mainContainer #viewerContainer {
  top: 0 !important; /* move doc up into empty bar space */
}


  /* VODAL */
    .vodal-dialog {
      width: 95%;
    }
    .vodal-heading > h4 {
      color: #3498db;
      margin-top: 0;
      margin-bottom: 20px;
    }
    .vodal-middle > button {
      background-color: #3498db;
      text-transform: uppercase;
      padding: 10px 15px;
      font-weight: 700;
      width: 100%;
      margin-bottom: 10px;
    }
    .vodal-footer {
      margin: auto -15px -15px;
      border-top: 1px solid #eaeaea;
      text-align: right;
    }
    .vodal-footer > a {
      margin: 0;
      text-transform: uppercase;
      padding: 10px 15px;
      width: 100%;
      border-radius: 0 0 3px 3px;
      background-color: #FFF;
    }

    .editorControls  {
      font-size: 18px !important;
    }

    .editorControls .divisor {
      border-left: 1px solid #ddd;
      padding-left: 2px;
      padding-right: 2px;
      width: 2px;
      height: 10px !important;
      margin-top: 2px;
    }

    .editorControls i {
      margin-right: 2px;
      cursor: hand;
      cursor: pointer;
    }
  /* ./VODAL */


  /* TOOLTIPS */
    .tooltip {
      display: block !important;
      padding: 4px;
      z-index: 20000;
    }

    .tooltip .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }

    .tooltip tooltip-arrow {
      display: none;
    }

    .tooltip[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }

    .tooltip.tab-tooltip {
      display: none !important;
    }
    @media (min-width: 992px) {
      .tooltip.tab-tooltip {
        display: block !important;
      }
    }
    .tooltip.preview-tooltip {
      display: none !important;
    }
    @media (min-width: 768px) {
      .tooltip.preview-tooltip {
        display: block !important;
      }
    }
  /* ./TOOLTIPS */
</style>



// WEBPACK FOOTER //
// CertificadoEditor.vue?a6ca34f0